import { Injectable, inject } from '@angular/core';
import { camelCase } from 'lodash-es';
import { AccessLevel, AccessLevels } from './app-state-types';
import { AppStateService } from './app-state.service';

@Injectable({
	providedIn: 'root',
})
export class UserAccessService {
	public appState = inject(AppStateService);

	/**
	 * Gets the AccessLevel for a control path.
	 * @param controlPath
	 * @returns
	 */
	getAccessLevelForControlPath(
		controlPath: string,
		opts?: {
			forceRootLevelSecurityMap: boolean;
		},
	): AccessLevel {
		if (!controlPath) {
			return AccessLevels.Full;
		}

		const { forceRootLevelSecurityMap } = opts || { forceRootLevelSecurityMap: false };
		const securityMap = forceRootLevelSecurityMap
			? this.appState.getFlattenedSecurityMapForAccessCheck()
			: this.appState.flattenedSecurityMap;

		const hasSecurityMap = securityMap && Object.keys(securityMap).length > 0;
		if (!hasSecurityMap) {
			// Force logout
			return AccessLevels.Logout;
		}

		if (!controlPath) {
			return AccessLevels.Full;
		}

		if (controlPath.includes('-')) {
			console.warn(`Control path '${controlPath}' contains a dash. Use camelCase instead.`);
		}

		controlPath = this.normaliseControlPath(controlPath);
		const entry = securityMap && securityMap[controlPath];
		if (!entry) {
			return AccessLevels.Full;
		}

		return entry;
	}

	/**
	 * Determines whether a control path is accessible (i.e. not no access).
	 * @param controlPath
	 * @returns
	 */
	canAccessControlPath(controlPath: string): boolean {
		return this.getAccessLevelForControlPath(controlPath) !== AccessLevels.None;
	}

	/**
	 * Normalises a control path, converting dot-separated parts to dot-separated camelCase parts.
	 * @param controlPath
	 * @returns
	 */
	normaliseControlPath(controlPath: string): string {
		controlPath ||= '';
		const parts = controlPath.split('.');
		const normalised = parts.map((p) => camelCase(p)).join('.');
		return normalised;
	}

	dumpAccessLevelsForRootPath(rootPath: string): void {
		const securityMap = this.appState.flattenedSecurityMap;
		if (!securityMap) {
			return;
		}

		const keys = Object.keys(securityMap).filter((k) => k.startsWith(rootPath));
		keys.forEach((k) => {
			console.log(`${k}: ${securityMap[k]}`);
		});
	}
}
